import axios from 'axios'
import { BUSCAR_ITINERARIOS_FUTURO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';
import { salvarCacheItinerarios, carregarCacheItinerarios } from '../../util/offlineStorage';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function buscarItinerariosFuturo(codigo, codigoRota, pagina, registrosPorPagina, filtros) {
  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
  const url = `${URL}/itinerario/empresa/${codigo}/rota/${codigoRota}/itinerarios/${urlFiltros}`;
  const chaveData = filtros && filtros.data ? filtros.data : 'futuro';

  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
    .then(response => {
      salvarCacheItinerarios(`${codigo}_futuro_${chaveData}`, chaveData, response.data);
      return dispatch({ type: BUSCAR_ITINERARIOS_FUTURO, payload: response });
    })
    .catch(erro => {
      if (!navigator.onLine || (erro.code && erro.code === 'ECONNABORTED') || !erro.response) {
        const cache = carregarCacheItinerarios(`${codigo}_futuro_${chaveData}`, chaveData);
        if (cache) {
          return dispatch({ type: BUSCAR_ITINERARIOS_FUTURO, payload: { data: cache } });
        }
      }
      throw erro;
    });
}